import { Grid, Typography } from '@mui/material'
import React, { ChangeEvent } from 'react'
import { ContentEditableInfo } from '../NewTask/ContentEditableInfo'

type SectionPropsType = {
  title: string
  newSystemInfoFromState: string
  setNewSystemInfoInParent: (newInfo: string) => void
  addFileToNewSystemInfo: (event: ChangeEvent<HTMLInputElement>) => void
}

export const InfoSection = (props: SectionPropsType) => {
  return (
    <>
      <Typography className='titleHover'>
        <b>{props.title}</b>
      </Typography>
      <Grid item xl={12} xs={12} >
              <hr />
            </Grid>
      <Grid container className="comment">
      <ContentEditableInfo systemInfo={props.newSystemInfoFromState} setHtml={props.setNewSystemInfoInParent}  addFileToSystemInfo={props.addFileToNewSystemInfo}/>
      </Grid>
    </>
  )
}
